/* Beautiful UI primitives — hand-ported from beautifului.dev
   (github.com/TurboKach/ai-native-react-components, MIT © 2026 Turbo).
   Colours come from the shared semantic tokens; keyframes are ported
   verbatim with a bui- prefix to avoid collisions. */

@keyframes bui-shimmer-text {
  0% {
    background-position: 150%;
  }
  100% {
    background-position: -50%;
  }
}
@keyframes bui-pixel-on {
  0%,
  100% {
    opacity: 0.15;
  }
  18%,
  42% {
    opacity: 1;
  }
  62% {
    opacity: 0.15;
  }
}
@keyframes bui-pop-in {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes bui-fade-up {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bui-typing-dot {
  0%,
  60%,
  100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

/* Brief entrances and status changes; repeated polling keeps the same DOM identity. */
@media (prefers-reduced-motion: no-preference) {
  .ai-task-enter {
    animation: bui-fade-up 180ms cubic-bezier(0.23, 1, 0.32, 1) both;
  }
  .ai-task-status {
    animation: bui-pop-in 160ms cubic-bezier(0.23, 1, 0.32, 1) both;
  }
}
